// extracted by css-extract-rspack-plugin
export default {"well":"_76f675ec","padding":"_b87876f","margin":"_56b916c0","label":"_cc8695d8"};